"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryLetRef = exports.AliasRef = exports.Query = exports.SortClause = exports.ReturnClause = exports.ByColumn = exports.ByExpression = exports.ByDirection = exports.Sort = exports.Without = exports.With = exports.LetClause = exports.AliasedQuerySource = void 0;
var expression_1 = require("./expression");
var context_1 = require("../runtime/context");
var util_1 = require("../util/util");
var comparison_1 = require("../util/comparison");
var builder_1 = require("./builder");
var AliasedQuerySource = /** @class */ (function () {
    function AliasedQuerySource(json) {
        this.alias = json.alias;
        this.expression = (0, builder_1.build)(json.expression);
    }
    return AliasedQuerySource;
}());
exports.AliasedQuerySource = AliasedQuerySource;
var LetClause = /** @class */ (function () {
    function LetClause(json) {
        this.identifier = json.identifier;
        this.expression = (0, builder_1.build)(json.expression);
    }
    return LetClause;
}());
exports.LetClause = LetClause;
var With = /** @class */ (function (_super) {
    __extends(With, _super);
    function With(json) {
        var _this = _super.call(this, json) || this;
        _this.alias = json.alias;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.suchThat = (0, builder_1.build)(json.suchThat);
        return _this;
    }
    With.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var records, returns;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.expression.execute(ctx)];
                    case 1:
                        records = _a.sent();
                        if (!(0, util_1.typeIsArray)(records)) {
                            records = [records];
                        }
                        return [4 /*yield*/, Promise.all(records.map(function (rec) {
                                var childCtx = ctx.childContext();
                                childCtx.set(_this.alias, rec);
                                return _this.suchThat.execute(childCtx);
                            }))];
                    case 2:
                        returns = _a.sent();
                        return [2 /*return*/, returns.some(function (x) { return x; })];
                }
            });
        });
    };
    return With;
}(expression_1.Expression));
exports.With = With;
var Without = /** @class */ (function (_super) {
    __extends(Without, _super);
    function Without(json) {
        return _super.call(this, json) || this;
    }
    Without.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.exec.call(this, ctx)];
                    case 1: return [2 /*return*/, !(_a.sent())];
                }
            });
        });
    };
    return Without;
}(With));
exports.Without = Without;
// ELM-only, not a product of CQL
var Sort = /** @class */ (function (_super) {
    __extends(Sort, _super);
    function Sort() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Sort;
}(expression_1.UnimplementedExpression));
exports.Sort = Sort;
var ByDirection = /** @class */ (function (_super) {
    __extends(ByDirection, _super);
    function ByDirection(json) {
        var _this = _super.call(this, json) || this;
        _this.direction = json.direction;
        _this.low_order = _this.direction === 'asc' || _this.direction === 'ascending' ? -1 : 1;
        _this.high_order = _this.low_order * -1;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ByDirection.prototype.exec = function (ctx, a, b) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (a === b) {
                    return [2 /*return*/, 0];
                }
                else if (a.isQuantity && b.isQuantity) {
                    if (a.before(b)) {
                        return [2 /*return*/, this.low_order];
                    }
                    else {
                        return [2 /*return*/, this.high_order];
                    }
                }
                else if (a < b) {
                    return [2 /*return*/, this.low_order];
                }
                else {
                    return [2 /*return*/, this.high_order];
                }
                return [2 /*return*/];
            });
        });
    };
    return ByDirection;
}(expression_1.Expression));
exports.ByDirection = ByDirection;
var ByExpression = /** @class */ (function (_super) {
    __extends(ByExpression, _super);
    function ByExpression(json) {
        var _this = _super.call(this, json) || this;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.direction = json.direction;
        _this.low_order = _this.direction === 'asc' || _this.direction === 'ascending' ? -1 : 1;
        _this.high_order = _this.low_order * -1;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ByExpression.prototype.exec = function (ctx, a, b) {
        return __awaiter(this, void 0, void 0, function () {
            var sctx, a_val, b_val;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sctx = ctx.childContext(a);
                        return [4 /*yield*/, this.expression.execute(sctx)];
                    case 1:
                        a_val = _a.sent();
                        sctx = ctx.childContext(b);
                        return [4 /*yield*/, this.expression.execute(sctx)];
                    case 2:
                        b_val = _a.sent();
                        if (a_val === b_val || (a_val == null && b_val == null)) {
                            return [2 /*return*/, 0];
                        }
                        else if (a_val == null || b_val == null) {
                            return [2 /*return*/, a_val == null ? this.low_order : this.high_order];
                        }
                        else if (a_val.isQuantity && b_val.isQuantity) {
                            return [2 /*return*/, a_val.before(b_val) ? this.low_order : this.high_order];
                        }
                        else {
                            return [2 /*return*/, a_val < b_val ? this.low_order : this.high_order];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ByExpression;
}(expression_1.Expression));
exports.ByExpression = ByExpression;
var ByColumn = /** @class */ (function (_super) {
    __extends(ByColumn, _super);
    function ByColumn(json) {
        var _this = _super.call(this, json) || this;
        _this.expression = (0, builder_1.build)({
            name: json.path,
            type: 'IdentifierRef'
        });
        return _this;
    }
    return ByColumn;
}(ByExpression));
exports.ByColumn = ByColumn;
var ReturnClause = /** @class */ (function () {
    function ReturnClause(json) {
        this.expression = (0, builder_1.build)(json.expression);
        this.distinct = json.distinct != null ? json.distinct : true;
    }
    return ReturnClause;
}());
exports.ReturnClause = ReturnClause;
var SortClause = /** @class */ (function () {
    function SortClause(json) {
        this.by = (0, builder_1.build)(json != null ? json.by : undefined);
    }
    SortClause.prototype.sort = function (ctx, values) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.by) {
                    return [2 /*return*/, (0, util_1.asyncMergeSort)(values, function (a, b) { return __awaiter(_this, void 0, void 0, function () {
                            var order, _i, _a, item;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        order = 0;
                                        _i = 0, _a = this.by;
                                        _b.label = 1;
                                    case 1:
                                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                                        item = _a[_i];
                                        return [4 /*yield*/, item.exec(ctx, a, b)];
                                    case 2:
                                        // Do not use execute here because the value of the sort order is not important.
                                        order = _b.sent();
                                        if (order !== 0) {
                                            return [3 /*break*/, 4];
                                        }
                                        _b.label = 3;
                                    case 3:
                                        _i++;
                                        return [3 /*break*/, 1];
                                    case 4: return [2 /*return*/, order];
                                }
                            });
                        }); })];
                }
                return [2 /*return*/, values];
            });
        });
    };
    return SortClause;
}());
exports.SortClause = SortClause;
var toDistinctList = function (xList) {
    var yList = [];
    xList.forEach(function (x) {
        if (!yList.some(function (y) { return (0, comparison_1.equals)(x, y); })) {
            yList.push(x);
        }
    });
    return yList;
};
var AggregateClause = /** @class */ (function (_super) {
    __extends(AggregateClause, _super);
    function AggregateClause(json) {
        var _this = _super.call(this, json) || this;
        _this.identifier = json.identifier;
        _this.expression = (0, builder_1.build)(json.expression);
        _this.starting = json.starting ? (0, builder_1.build)(json.starting) : null;
        _this.distinct = json.distinct != null ? json.distinct : true;
        return _this;
    }
    AggregateClause.prototype.aggregate = function (returnedValues, ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var aggregateValue, _a, _i, returnedValues_1, contextValues, childContext;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.starting != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.starting.exec(ctx)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _b.label = 3;
                    case 3:
                        aggregateValue = _a;
                        _i = 0, returnedValues_1 = returnedValues;
                        _b.label = 4;
                    case 4:
                        if (!(_i < returnedValues_1.length)) return [3 /*break*/, 7];
                        contextValues = returnedValues_1[_i];
                        childContext = ctx.childContext(contextValues);
                        childContext.set(this.identifier, aggregateValue);
                        return [4 /*yield*/, this.expression.exec(childContext)];
                    case 5:
                        aggregateValue = _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [2 /*return*/, aggregateValue];
                }
            });
        });
    };
    return AggregateClause;
}(expression_1.Expression));
var Query = /** @class */ (function (_super) {
    __extends(Query, _super);
    function Query(json) {
        var _this = _super.call(this, json) || this;
        _this.sources = new MultiSource(json.source.map(function (s) { return new AliasedQuerySource(s); }));
        _this.letClauses = json.let != null ? json.let.map(function (d) { return new LetClause(d); }) : [];
        _this.relationship = json.relationship != null ? (0, builder_1.build)(json.relationship) : [];
        _this.where = (0, builder_1.build)(json.where);
        _this.returnClause = json.return != null ? new ReturnClause(json.return) : null;
        _this.aggregateClause = json.aggregate != null ? new AggregateClause(json.aggregate) : null;
        _this.aliases = _this.sources.aliases();
        _this.sortClause = json.sort != null ? new SortClause(json.sort) : null;
        return _this;
    }
    Query.prototype.isDistinct = function () {
        if (this.aggregateClause != null && this.aggregateClause.distinct != null) {
            return this.aggregateClause.distinct;
        }
        else if (this.returnClause != null && this.returnClause.distinct != null) {
            return this.returnClause.distinct;
        }
        return true;
    };
    Query.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var returnedValues;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        returnedValues = [];
                        return [4 /*yield*/, this.sources.forEach(ctx, function (rctx) { return __awaiter(_this, void 0, void 0, function () {
                                var _i, _a, def, _b, _c, _d, relations, passed, _e, _f, val;
                                return __generator(this, function (_g) {
                                    switch (_g.label) {
                                        case 0:
                                            _i = 0, _a = this.letClauses;
                                            _g.label = 1;
                                        case 1:
                                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                                            def = _a[_i];
                                            _c = (_b = rctx).set;
                                            _d = [def.identifier];
                                            return [4 /*yield*/, def.expression.execute(rctx)];
                                        case 2:
                                            _c.apply(_b, _d.concat([_g.sent()]));
                                            _g.label = 3;
                                        case 3:
                                            _i++;
                                            return [3 /*break*/, 1];
                                        case 4: return [4 /*yield*/, Promise.all(this.relationship.map(function (rel) {
                                                var child_ctx = rctx.childContext();
                                                return rel.execute(child_ctx);
                                            }))];
                                        case 5:
                                            relations = _g.sent();
                                            _e = (0, util_1.allTrue)(relations);
                                            if (!_e) return [3 /*break*/, 9];
                                            if (!this.where) return [3 /*break*/, 7];
                                            return [4 /*yield*/, this.where.execute(rctx)];
                                        case 6:
                                            _f = _g.sent();
                                            return [3 /*break*/, 8];
                                        case 7:
                                            _f = true;
                                            _g.label = 8;
                                        case 8:
                                            _e = (_f);
                                            _g.label = 9;
                                        case 9:
                                            passed = _e;
                                            if (!passed) return [3 /*break*/, 12];
                                            if (!(this.returnClause != null)) return [3 /*break*/, 11];
                                            return [4 /*yield*/, this.returnClause.expression.execute(rctx)];
                                        case 10:
                                            val = _g.sent();
                                            returnedValues.push(val);
                                            return [3 /*break*/, 12];
                                        case 11:
                                            if (this.aliases.length === 1 && this.aggregateClause == null) {
                                                returnedValues.push(rctx.get(this.aliases[0]));
                                            }
                                            else {
                                                returnedValues.push(rctx.context_values);
                                            }
                                            _g.label = 12;
                                        case 12: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        if (this.isDistinct()) {
                            returnedValues = toDistinctList(returnedValues);
                        }
                        if (!(this.aggregateClause != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.aggregateClause.aggregate(returnedValues, ctx)];
                    case 2:
                        returnedValues = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(this.sortClause != null)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.sortClause.sort(ctx, returnedValues)];
                    case 4:
                        returnedValues = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (this.sources.returnsList() || this.aggregateClause != null) {
                            return [2 /*return*/, returnedValues];
                        }
                        else {
                            return [2 /*return*/, returnedValues[0]];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Query;
}(expression_1.Expression));
exports.Query = Query;
var AliasRef = /** @class */ (function (_super) {
    __extends(AliasRef, _super);
    function AliasRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        return _this;
    }
    AliasRef.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ctx != null ? ctx.get(this.name) : undefined];
            });
        });
    };
    return AliasRef;
}(expression_1.Expression));
exports.AliasRef = AliasRef;
var QueryLetRef = /** @class */ (function (_super) {
    __extends(QueryLetRef, _super);
    function QueryLetRef(json) {
        return _super.call(this, json) || this;
    }
    return QueryLetRef;
}(AliasRef));
exports.QueryLetRef = QueryLetRef;
// The following is not defined by ELM but is helpful for execution
var MultiSource = /** @class */ (function () {
    function MultiSource(sources) {
        this.sources = sources;
        this.alias = this.sources[0].alias;
        this.expression = this.sources[0].expression;
        this.isList = true;
        if (this.sources.length > 1) {
            this.rest = new MultiSource(this.sources.slice(1));
        }
    }
    MultiSource.prototype.aliases = function () {
        var a = [this.alias];
        if (this.rest) {
            a = a.concat(this.rest.aliases());
        }
        return a;
    };
    MultiSource.prototype.returnsList = function () {
        return this.isList || (this.rest && this.rest.returnsList());
    };
    MultiSource.prototype.forEach = function (ctx, func) {
        return __awaiter(this, void 0, void 0, function () {
            var records;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.expression.execute(ctx)];
                    case 1:
                        records = _a.sent();
                        this.isList = (0, util_1.typeIsArray)(records);
                        records = this.isList ? records : [records];
                        return [2 /*return*/, Promise.all(records.map(function (rec) { return __awaiter(_this, void 0, void 0, function () {
                                var rctx;
                                return __generator(this, function (_a) {
                                    rctx = new context_1.Context(ctx);
                                    rctx.set(this.alias, rec);
                                    if (this.rest) {
                                        return [2 /*return*/, this.rest.forEach(rctx, func)];
                                    }
                                    else {
                                        return [2 /*return*/, func(rctx)];
                                    }
                                    return [2 /*return*/];
                                });
                            }); }))];
                }
            });
        });
    };
    return MultiSource;
}());
//# sourceMappingURL=query.js.map